import { DownOutlined } from "@ant-design/icons";
import { Collapse, Row } from "antd";
import { useState } from "react";
import BreadCrumb from "../../Components/BreadCrumb/BreadCrumb";
import Layout from "../../Components/Layout/Layout";
import styles from "./DataProtection.module.scss";
import { protectionData } from "./data";

const DataProtection = () => {
    const [activeKey, setActiveKey] = useState(0);

    const onAccordionChange = (key) => {
        setActiveKey(key);
    };

    return (
        <Layout title="Data Protection">
            <div className={`${styles.wrapper} container`}>
                <BreadCrumb
                    list={[
                        { name: "Home", link: "/" },
                        { name: "Service", link: "/data-protection" },
                        { name: "Data Protection", link: "/data-protection" },
                    ]}
                />

                <div className={styles.data_protection_content}>
                    <h2 className={styles.title}>Data protection</h2>

                    <div style={{ marginTop: 5 }}>
                        Welcome to Desi Fresh! In the following we would like to
                        inform you which of your data we process if you use our
                        services via our website or our mobile applications.
                    </div>

                    {/* accordion */}
                    <Row>
                        <div className={styles.questions}>
                            <Collapse
                                accordion={true}
                                ghost={true}
                                expandIcon={({ isActive }) => (
                                    <DownOutlined
                                        size={20}
                                        rotate={isActive ? 180 : 0}
                                        style={{
                                            color: isActive && "green",
                                        }}
                                    />
                                )}
                                bordered={false}
                                expandIconPosition="end"
                                activeKey={activeKey}
                                onChange={onAccordionChange}
                            >
                                {protectionData.map((item) => (
                                    <Collapse.Panel
                                        header={
                                            <span
                                                style={{
                                                    marginLeft: 5,
                                                    color:
                                                        +activeKey === item.key
                                                            ? "green"
                                                            : "",
                                                }}
                                            >
                                                {item.question}
                                            </span>
                                        }
                                        key={item.key}
                                    >
                                        <span>{item.answer}</span>
                                    </Collapse.Panel>
                                ))}
                            </Collapse>
                        </div>
                    </Row>
                </div>
            </div>
        </Layout>
    );
};

export default DataProtection;
